import { Link, NavLink } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { useState } from "react";

const NAV = [
  { to: "/metodo-oasi", label: "Metodo" },
  { to: "/pacchetti", label: "Pacchetti" },
  { to: "/super-garanzia", label: "Garanzia" },
  { to: "/guida-ristrutturazione-bagno", label: "Guida" },
  { to: "/faq", label: "FAQ" },
  { to: "/contatti", label: "Contatti" },
];

const Logo = () => (
  <div className="flex items-center">
    <div className="logo-mark text-anthracite text-[22px] md:text-[26px]">
      <span className="block leading-[0.9]">OASI</span>
      <span className="block leading-[0.9]">BAGNI<sup className="text-[9px] ml-0.5 align-top">®</sup></span>
    </div>
  </div>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-warm-white/90 backdrop-blur-md border-b border-brand">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo"><Logo /></Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((it) => (
            <NavLink key={it.to} to={it.to} className={({ isActive }) => `text-sm transition-colors ${isActive ? "text-oasi-green font-medium" : "text-anthracite hover:text-oasi-green"}`} data-testid={`nav-${it.label.toLowerCase()}`}>
              {it.label}
            </NavLink>
          ))}
          <Link to="/prenota-sopralluogo" className="btn-primary text-sm px-6 py-2.5 rounded-full font-medium" data-testid="navbar-cta">Richiedi sopralluogo gratuito</Link>
        </nav>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="navbar-menu-toggle">
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-brand bg-warm-white">
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV.map((it) => (
              <NavLink key={it.to} to={it.to} onClick={() => setOpen(false)} className="text-anthracite text-base py-1">{it.label}</NavLink>
            ))}
            <Link to="/prenota-sopralluogo" onClick={() => setOpen(false)} className="btn-primary text-sm px-5 py-3 rounded-full text-center mt-2">Richiedi sopralluogo gratuito</Link>
          </div>
        </div>
      )}
    </header>
  );
}
